import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    CircularProgress
} from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import { GlobalState } from "context/GlobalContext";

export default function DiscountActionPage() {

    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");

    const action = searchParams.get("action");

    const [loading, setLoading] = useState(true);

    const [status, setStatus] = useState("");

    const [error, setError] = useState("");

    const [reason, setReason] = useState("");

    const [openRejectDialog, setOpenRejectDialog] = useState(false);
    const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

    // ==========================================
    // USE EFFECT
    // ==========================================

    useEffect(() => {

        if (!token || !action) {

            setError("Invalid Link");

            setLoading(false);

            return;
        }

        // APPROVE FLOW
        if (action === "approve") {

            approveDiscount();
        }

        // REJECT FLOW
        if (action === "reject") {

            setOpenRejectDialog(true);

            setLoading(false);
        }

    }, []);

    // ==========================================
    // APPROVE API
    // ==========================================

    const approveDiscount = async () => {

        try {
            setLoadingOpen(true);

            await pythonVmInstance.patch(
                "/discount-master/approve",
                {
                    token
                }
            );

            setStatus("approved");
            setLoadingOpen(false);

        } catch (err) {

            setError(
                err?.response?.data?.message ||
                "Approval Failed"
            );
            setLoadingOpen(false);

        }
    };

    // ==========================================
    // REJECT API
    // ==========================================

    const rejectDiscount = async () => {

        try {

            setLoadingOpen(true);

            await pythonVmInstance.patch(
                "/discount-master/reject",
                {
                    token,
                    reason
                }
            );

            setStatus("rejected");

            setOpenRejectDialog(false);
            setLoadingOpen(false);

        } catch (err) {

            setError(
                err?.response?.data?.message ||
                "Reject Failed"
            );
            setLoadingOpen(false);

        }
    };

    // ==========================================
    // ERROR UI
    // ==========================================

    if (error) {

        return (
            <div
                style={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: "20px"
                }}
            >

                <ErrorOutlineIcon
                    style={{
                        fontSize: "100px",
                        color: "#f44336"
                    }}
                />

                <h1>
                   {error}
                </h1>

            </div>
        );
    }

    // ==========================================
    // MAIN UI
    // ==========================================

    return (
        <>

            {/* APPROVED UI */}

            {status === "approved" && (

                <div
                    style={{
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        gap: "20px"
                    }}
                >

                    <CheckCircleIcon
                        style={{
                            fontSize: "120px",
                            color: "#4caf50"
                        }}
                    />

                    <h1
                        style={{
                            color: "#4caf50"
                        }}
                    >
                        Discount Approved
                    </h1>

                </div>
            )}

            {/* REJECTED UI */}

            {status === "rejected" && (

                <div
                    style={{
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        gap: "20px"
                    }}
                >

                    <CancelIcon
                        style={{
                            fontSize: "120px",
                            color: "#f44336"
                        }}
                    />

                    <h1
                        style={{
                            color: "#f44336"
                        }}
                    >
                        Discount Rejected
                    </h1>

                </div>
            )}

            {/* REJECT DIALOG */}

            <Dialog
                open={openRejectDialog}
                maxWidth="sm"
                fullWidth
            >

                <DialogTitle>
                    Reject Discount
                </DialogTitle>

                <DialogContent>

                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        rows={5}
                        margin="dense"
                        label="Reject Reason"
                        value={reason}
                        onChange={(e) =>
                            setReason(e.target.value)
                        }
                    />

                </DialogContent>

                <DialogActions>

                    <Button
                        variant="outlined"
                        onClick={() =>
                            setOpenRejectDialog(false)
                        }
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        disabled={!reason}
                        onClick={rejectDiscount}
                    >
                        Submit
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    );
}